/* eslint-disable no-param-reassign */
import type { StandardChartLayerSpec } from '../../../../core/layer';
import type { Spec as GroupedStackedBarLayerSpec } from '../../../../layer/preset/bar/groupedStackedBar';
import {
  BaseSpec,
  ILayerTypeSpec,
  createDataTypeValidator,
  createEncodingValidator,
  createLayerProcessor
} from '../baseProcessor';

export type Spec = BaseSpec;

// 扩展ILayerTypeSpec以包含__isEncodingValid属性
interface GroupedStackedBarLayerTypeWithFields extends ILayerTypeSpec {
  __isEncodingValid?: boolean;
}

type GroupedStackedBarLayerType = StandardChartLayerSpec &
  GroupedStackedBarLayerSpec &
  GroupedStackedBarLayerTypeWithFields;

// 创建分组堆叠柱状图数据类型验证器
const validateGroupedStackedBarDataTypes = createDataTypeValidator('groupedStackedBar', [
  { field: 'x', type: ['string', 'date'] },
  { field: 'y', type: 'number' },
  { field: 'group', type: 'string' },
  { field: 'group2', type: 'string' }
]);

// 创建分组堆叠柱状图编码验证器
const validateGroupedStackedBarEncoding = createEncodingValidator([
  { field: 'x' },
  { field: 'y' },
  { field: 'group' },
  { field: 'group2' }
]);

// 创建并导出分组堆叠柱状图处理器
export const groupedStackedBar = createLayerProcessor<GroupedStackedBarLayerType>(
  'groupedStackedBar',
  validateGroupedStackedBarEncoding,
  validateGroupedStackedBarDataTypes
);
